import { Component, inject } from '@angular/core';
import { LayoutService } from '../service/layout.service';


@Component({
    standalone: true,
    selector: '[app-footer]',
    template: ` <div class="footer-start">
            <img src="layout/logo-dark.svg" alt="logo" />
            <span class="app-name">Cerema</span>
        </div>
        <div class="footer-right">
            <span>v{{ layoutService.layoutConfig().appVersion || '0.0.0' }}</span>
        </div>`,
    host: {
        class: 'layout-footer'
    }
})
export class AppFooter {
    layoutService = inject(LayoutService);
}
